import { Form as AntForm } from "antd";
import type { FormInstance } from "antd/es/form/Form";
import { useForm } from "antd/es/form/Form";
import type { FC, PropsWithChildren } from "react";

import { ActionBar } from "../ActionBar/ActionBar";
import { ResetButton } from "../FeatureButtons/ResetButton";
import { SearchButton } from "../FeatureButtons/SearchButton";
import { SubmitButton } from "../FeatureButtons/SubmitButton";
import { VerticalFormLabelColonStyle } from "../Form/formFieldLabelPositioning/styles/FormFieldsStyle";

/**
 * Drawer Form properties
 * */
type DrawerFormProps = {
    onSubmit?: Function;
    onReset?: () => void;
    form?: FormInstance;
    useSubmitButton?: boolean;
    submitLabel?: string;
} & PropsWithChildren;

/**
 * Default component for the drawer form
 * */
export const DrawerForm: FC<DrawerFormProps> = ({ onSubmit, onReset, form: externalForm, children, useSubmitButton, submitLabel }) => {
    const [internalForm] = useForm();
    const form = externalForm || internalForm;

    const onResetClicked = () => {
        form.resetFields();
        if (onReset) {
            onReset();
        }
    };

    const onSubmitClicked = async () => {
        if (!onSubmit) return;

        try {
            const values = await form.validateFields();
            onSubmit(values);
        } catch {
            // Validation errors are already shown by AntD
        }
    };

    return (
        <>
            {/* vertical placement of labels */}
            <VerticalFormLabelColonStyle>
                <AntForm form={form} name="batchAdd" layout="vertical" autoComplete="off">
                    {children}
                </AntForm>
            </VerticalFormLabelColonStyle>
            <ActionBar className="left">
                {useSubmitButton ? (
                    <SubmitButton isDisabled={false} onClick={onSubmitClicked} label={submitLabel} />
                ) : (
                    <SearchButton isDisabled={false} callback={onSubmitClicked} />
                )}
                <ResetButton isDisabled={false} callback={onResetClicked} />
            </ActionBar>
        </>
    );
};
